/**
 * LiveVideo (web) — une vraie piste LiveKit dans une fente de la scène (`renderVideo`) : la
 * `<video>` de `@livekit/components-react`, qui remplit sa tuile ; ma caméra en miroir, l'écran
 * partagé et la caméra du masteur en grand entiers (`contain`, `liveVideoFit`) : autour, le fond de la
 * tuile, la `<video>` n'en pose pas.
 */
import { VideoTrack, type TrackReference } from "@livekit/components-react"
import React from "react"

import { type UILiveVideoFit, type UILiveVideoSource } from "../../../types/studentLive"
import { liveVideoFit } from "./liveTrackPick"

export function LiveVideo({
    track,
    source,
    fit,
}: {
    track: TrackReference
    source: UILiveVideoSource
    fit?: UILiveVideoFit
}) {
    return (
        <VideoTrack
            trackRef={track}
            style={{
                width: "100%",
                height: "100%",
                objectFit: liveVideoFit(source, fit),
                backgroundColor: "transparent",
                transform: source === "me" ? "scaleX(-1)" : undefined,
            }}
        />
    )
}
